import React from 'react';
import Instagram from '@material-ui/icons/Instagram';

export default function InstagramIcon(props) {
    const { ...other } = props;

    return (
        <Instagram {...other} />
    );
}